import { Icon } from "@chakra-ui/react";
import React from "react";

const OverheatIcon = (props) => (
  <Icon viewBox="0 0 14.27 15" {...props}>
    <defs>
      <clipPath id="clip-path">
        <rect width="14.27" height="15" fill="currentColor" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip-path)">
      <path
        d="M36.924,5.043a.46.46,0,1,0,0-.921H34.568V2.482h2.355a.46.46,0,1,0,0-.921H34.568v-.9a.658.658,0,1,0-1.315,0V8.372a1.973,1.973,0,1,0,1.315,0V7.6h2.355a.46.46,0,1,0,0-.921H34.568V5.043Z"
        transform="translate(-26.771 0)"
        fill="currentColor"
      />
      <path
        d="M13.744,81.784a.524.524,0,0,1-.349-.132l-.867-.769a.6.6,0,0,0-.812-.007l-.482.444A1.656,1.656,0,0,1,9,81.32l-.483-.444a.6.6,0,0,0-.8,0l-.482.444A1.656,1.656,0,0,1,5,81.32l-.482-.444a.6.6,0,0,0-.8,0l-.483.445a1.656,1.656,0,0,1-2.23,0l-.825-.727a.526.526,0,0,1,.7-.789l.833.735a.6.6,0,0,0,.813.008L3,80.1a1.656,1.656,0,0,1,2.23,0l.482.444a.6.6,0,0,0,.8,0L7,80.1a1.656,1.656,0,0,1,2.23,0l.483.444a.6.6,0,0,0,.8,0L11,80.1a1.656,1.656,0,0,1,2.23,0l.86.762a.526.526,0,0,1-.349.92"
        transform="translate(0 -66.784)"
        fill="currentColor"
      />
      <path
        d="M2.743,60.525a1.681,1.681,0,0,1-.826-.215l-.244-.138a.627.627,0,0,0-.472-.057l-.535.148a.526.526,0,1,1-.28-1.014L.921,59.1a1.686,1.686,0,0,1,1.271.155l.244.138a.626.626,0,0,0,.465.059l.78-.205a.526.526,0,1,1,.268,1.018l-.78.205a1.674,1.674,0,0,1-.426.055"
        transform="translate(0 -49.491)"
        fill="currentColor"
      />
      <path
        d="M63.735,60.9a1.751,1.751,0,0,1-.4-.047l-.78-.184a.46.46,0,1,1,.211-.9l.78.184a.813.813,0,0,0,.545-.061l.244-.123a1.747,1.747,0,0,1,1.19-.131l.535.132a.46.46,0,1,1-.221.894l-.535-.132a.815.815,0,0,0-.554.059l-.244.123a1.706,1.706,0,0,1-.769.182"
        transform="translate(-52.137 -49.952)"
        fill="currentColor"
      />
    </g>
  </Icon>
);

export default React.memo(OverheatIcon);
